import { render } from "./TalkerView.vue?vue&type=template&id=049de0ab"
import script from "./TalkerView.vue?vue&type=script&lang=js"
export * from "./TalkerView.vue?vue&type=script&lang=js"

import exportComponent from "Z:\\Adamovyveci\\uhkprojects\\owezaverecny\\secutalk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__